module.exports = __webpack_public_path__ + "static/img/bgxkskkzz.8726393.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bgxkskkzz.png
// module id = mHaU
// module chunks = 1